<template>
  <div class="text-input">
      <p class="label">{{ label }}</p>
      <input ref="input" :type="type" @input="updateValue()">
      <p class="warning"></p>
  </div>
</template>

<script>
export default {
    props: ['label', 'type'],
    methods: {
        updateValue(){
            this.$emit('input', this.$refs.input.value)
        }
    }
}
</script>

<style lang="scss" scoped>
    .text-input {
        margin-bottom: 20px;
    }

    input {
        border: none;
        border-radius: 100px;
        background-color: $lightGrey;
        width: 100%;
        font-size: 14px;
        padding: 10px 15px;
        margin-top: 10px;
    }

    .label {
        margin-left: 5px;
        font-size: 14px;
    }
</style>